import React, { useState } from 'react';
import { showToast } from '../../helpers/Utils';

export default function FrameUnits({order,disabled,onSaved}) {
 const quantity=Math.max(1,Number(order.Quantity)||1);
 const [busy,setBusy]=useState(false);
 const units=order.frameUnits || [];
 const getUnit=index=>units.find(u=>u.unitIndex===index) || (index===1 ? {macAddress:order.FrameMAC,serialNumber:order.FrameSN}:{});
 const request=async(path,options)=>{
  const response=await fetch(`${import.meta.env.VITE_BASE_URL}/order/${encodeURIComponent(order.ItemID)}/${path}`,{...options,headers:{Authorization:`Bearer ${localStorage.getItem('authToken')}`,...options.headers}});
  const body=await response.json();
  if(!response.ok) throw Error(body.message || 'Unable to save frame identifiers.');
  return body;
 };
 const save=async(index,data,photo)=>{
  setBusy(true);
  try {
   if(photo){
    if(!photo.type.startsWith('image/') || photo.size>10*1024*1024) throw Error('Select an image smaller than 10MB.');
    const form=new FormData();form.append('photo',photo);form.append('unitIndex',index);
    await request('photos',{method:'POST',body:form});
   } else await request(`frame-units/${index}`,{method:'PUT',headers:{'Content-Type':'application/json'},body:JSON.stringify(data)});
   await onSaved();showToast('Frame identifiers saved.','success');
  } catch(e){await onSaved();showToast(e.message,'error');} finally {setBusy(false);}
 };
 const completed=Array.from({length:quantity},(_,i)=>getUnit(i+1)).filter(u=>u.macAddress).length;
 return <section className="order-photo-section">
  <h6>Frame identification — {completed}/{quantity} MAC addresses recorded</h6>
  {Array.from({length:quantity},(_,i)=>{
   const index=i+1,unit=getUnit(index);
   return <FrameUnit key={`${order.ItemID}-${index}-${unit.macAddress}-${unit.serialNumber}`} index={index} unit={unit} disabled={disabled||busy} onSave={save} photos={(order.orderPhotos||[]).filter(p=>p.unitIndex===index)}/>;
  })}
  {(order.orderPhotos||[]).some(p=>!p.unitIndex) && <details><summary>Previous photos (not assigned to a unit)</summary><PhotoList photos={order.orderPhotos.filter(p=>!p.unitIndex)}/></details>}
 </section>;
}
function PhotoList({photos}) {return <div className="order-photo-grid">{photos.map(p=><a key={p._id||p.url} href={p.url} target="_blank" rel="noreferrer"><img src={p.url} alt="Frame identification" style={{width:100,maxHeight:100,objectFit:'contain'}}/></a>)}</div>;}
function FrameUnit({index,unit,disabled,onSave,photos}) {
 const [macAddress,setMac]=useState(unit.macAddress||''),[serialNumber,setSn]=useState(unit.serialNumber||'');
 return <div style={{borderTop:'1px solid #ddd',padding:'16px 0'}}>
  <strong>Pro {index}</strong>
  <div className="frame-identifier-inputs">
   <label>MAC<input className="cp-input" value={macAddress} maxLength={17} disabled={disabled} placeholder="AA:BB:CC:DD:EE:FF" onChange={e=>setMac(e.target.value.toUpperCase())}/></label>
   <label>SN<input className="cp-input" value={serialNumber} maxLength={64} disabled={disabled} onChange={e=>setSn(e.target.value.toUpperCase())}/></label>
  </div>
  <button type="button" className="grey-btn cmn_btn my-2" disabled={disabled} onClick={()=>onSave(index,{macAddress,serialNumber})}>Save identifiers</button>
  <label style={{display:'block'}}>Take or choose frame photo<input type="file" accept="image/*" disabled={disabled} onChange={e=>{const file=e.target.files?.[0];e.target.value='';if(file)onSave(index,null,file);}}/></label>
  <PhotoList photos={photos}/>
 </div>;
}
